module.exports = __webpack_public_path__ + "static/media/cerraGray.4bd6a55a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/cerraGray.svg
// module id = 1872
// module chunks = 0